import PropTypes from 'prop-types';
import React from 'react';
import RatingOptionButton from '../../common/rating-option-button';
import { NPS_SCORES } from '../../constants/feedback-constants';

const NpsRating = ({ value, onChange }) => (
  <div className="flex justify-center gap-1">
    {NPS_SCORES.map((score) => (
      <RatingOptionButton
        key={score}
        score={score}
        label={String(score)}
        selected={value !== null && score <= value}
        className="feedback-nps-option"
        onSelect={onChange}
      />
    ))}
  </div>
);

NpsRating.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

NpsRating.defaultProps = {
  value: null,
};

export default NpsRating;
